/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Set_IncodeInputs */

const en_shortcut_keys_desc_set_incode = /** @type {(inputs: Shortcut_Keys_Desc_Set_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update the incode of the selected Event based on the current media time`)
};

const fr_shortcut_keys_desc_set_incode = /** @type {(inputs: Shortcut_Keys_Desc_Set_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre a jour l'incode de l'evenement selectionne selon le temps media actuel`)
};

const de_shortcut_keys_desc_set_incode = /** @type {(inputs: Shortcut_Keys_Desc_Set_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisiere den Incode des ausgewählten Ereignisses basierend auf der aktuellen Medienzeit.`)
};

const it_shortcut_keys_desc_set_incode = /** @type {(inputs: Shortcut_Keys_Desc_Set_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna l'INCODE dell'evento selezionato in base all'ora corrente del supporto`)
};

const ru_shortcut_keys_desc_set_incode = /** @type {(inputs: Shortcut_Keys_Desc_Set_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновите входящий код выбранного события в соответствии с текущим временем воспроизведения медиафайла.`)
};

const es_shortcut_keys_desc_set_incode = /** @type {(inputs: Shortcut_Keys_Desc_Set_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar la codificación del evento seleccionado en función del tiempo del medio actual`)
};

const zh_cn2_shortcut_keys_desc_set_incode = /** @type {(inputs: Shortcut_Keys_Desc_Set_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据当前媒体时间更新所选事件的编码`)
};

const ja_shortcut_keys_desc_set_incode = /** @type {(inputs: Shortcut_Keys_Desc_Set_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在のメディア時間に基づいて、選択したイベントのインコードを更新します。`)
};

const hi_shortcut_keys_desc_set_incode = /** @type {(inputs: Shortcut_Keys_Desc_Set_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान मीडिया समय के आधार पर चयनित इवेंट के इनकोड को अपडेट करें।`)
};

const pt_pt2_shortcut_keys_desc_set_incode = /** @type {(inputs: Shortcut_Keys_Desc_Set_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualize o código de entrada do evento selecionado com base no horário atual da mídia.`)
};

/**
* | output |
* | --- |
* | "Update the incode of the selected Event based on the current media time" |
*
* @param {Shortcut_Keys_Desc_Set_IncodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_set_incode = /** @type {((inputs?: Shortcut_Keys_Desc_Set_IncodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Set_IncodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_set_incode(inputs)
	if (locale === "de") return de_shortcut_keys_desc_set_incode(inputs)
	if (locale === "it") return it_shortcut_keys_desc_set_incode(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_set_incode(inputs)
	if (locale === "es") return es_shortcut_keys_desc_set_incode(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_set_incode(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_set_incode(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_set_incode(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_set_incode(inputs)
	return en_shortcut_keys_desc_set_incode(inputs)
});